import type { UiPalette } from '@theme/uiPalette.types'
import { deriveAccentFromMain } from '@theme/deriveAccentPalette'

/**
 * Menu header: inactive trong suốt, hover overlay trắng.
 * Item đang chọn dùng nền đậm hơn header (cùng `navItemActiveBg` của banhang).
 * Dòng active trong menu con vẫn là overlay trắng trên panel tối.
 */
const HEADER_ITEM_BG = 'transparent'
const HEADER_ITEM_HOVER_BG = 'rgba(255, 255, 255, 0.18)'
const DROPDOWN_ITEM_ACTIVE_BG = 'rgba(255, 255, 255, 0.22)'

/**
 * Các style antd cũ (header, bảng, button) đọc biến `--color-*`.
 * Map từ `UiPalette` để chúng đổi theo preset chọn ở ThemePickerPopover.
 */
export const syncPaletteToLegacyCssVars = (palette: UiPalette): void => {
  if (typeof document === 'undefined') return
  const accent = deriveAccentFromMain(palette.primary.main)
  const vars: Record<string, string> = {
    '--color-gray-dark': palette.neutral.text,
    '--color-gray-light': palette.neutral.outline,
    '--color-blue-dark': palette.primary.dark,
    '--color-blue-light': palette.primary.surface,
    '--color-blue-hover': palette.primary.light,
    '--color-white': '#ffffff',
    '--color-black': '#000000',
    '--color-primary': palette.primary.main,

    '--color-disabled-bg': palette.neutral.backgroundDeep,
    '--color-disabled-border': palette.neutral.outline,

    '--color-navbar-bg': palette.shell.headerSolid,
    '--color-content-bg': '#ffffff',
    '--color-layout-bg': palette.neutral.background,

    '--color-menu-normal': HEADER_ITEM_BG,
    '--color-menu-hover': HEADER_ITEM_HOVER_BG,
    '--color-menu-active': DROPDOWN_ITEM_ACTIVE_BG,
    '--color-nav-active': accent.navItemActiveBg,
    '--color-nav-active-hover': accent.navItemActiveBgHover,
    '--color-menu-panel': accent.menuPanelBg,

    '--color-table-header-bg': palette.table.headBg,
    '--color-table-header-text': palette.table.headText,
    '--color-table-row-hover': palette.table.rowHoverBg,
    '--color-table-border': palette.table.headBorder,

    '--color-btn-primary': palette.primary.main,
    '--color-btn-primary-hover': palette.primary.dark,
    '--color-btn-danger': palette.status.error,
    '--color-btn-danger-hover': palette.status.error,
    '--color-btn-default': palette.neutral.textMuted,
    '--color-btn-default-hover': palette.neutral.text,
    '--color-btn-success': palette.status.success,
    '--color-btn-success-hover': palette.status.success,
    '--color-btn-warning': palette.status.warning,
    '--color-btn-warning-hover': palette.status.warning,
    '--color-btn-info': palette.status.info,
    '--color-btn-info-hover': palette.secondary.dark,
  }

  const root = document.documentElement
  for (const [name, value] of Object.entries(vars)) {
    root.style.setProperty(name, value)
  }
}
